<template>
  <main v-if="visible" id="main" class="main-site">
    <div class="row">
      <div class="col-md-12">
        <h3 class="box-title">PARCELAMENTO POR FINANCIAMENTO SANTANDER</h3>
      </div>
    </div>

    <Loader
      v-if="loader"
      style="margin-left: auto; margin-right: auto; display: block"
    />

    <santander-stepper
      :steps="this.steps"
      v-on:next="proximo"
      v-on:previous="anterior"
      v-model="this.currentStep"
    />

    <transition name="fade">
      <template>
        <div class="panel panel-primary">
          <div
            @click="formPreAnalise.showForm = !formPreAnalise.showForm"
            class="panel-heading"
          >
            1 - DADOS PARA PRÉ-ANÁLISE
            <span class="pull-right">
              <i
                style="font-size: 1.5em"
                :class="
                  formPreAnalise.showForm
                    ? 'fa fa-arrow-down'
                    : 'fa fa-arrow-right'
                "
                aria-hidden="true"
              ></i>
            </span>
          </div>
          <div
            v-if="formPreAnalise.showForm"
            class="panel-body"
            style="padding-left: 35px"
          >
            <div>
              <div class="row">
                <form-helper
                  id="valorSimular"
                  :inputVar="formPreAnalise.valorSimular"
                  :form="formPreAnalise"
                  type="hidden"
                />
                <div class="col-md-4">
                  <form-helper
                    :inputVar="formPreAnalise.documentoCliente"
                    :form="formPreAnalise"
                    :label="isClienteFisico ? 'CPF' : 'CNPJ'"
                    :mask="
                      isClienteFisico ? '###.###.###-##' : '##.###.###/####-##'
                    "
                    :readonly="true"
                  />
                </div>
                <div class="col-md-4">
                  <form-helper
                    :inputVar="formPreAnalise.dataNasc"
                    :form="formPreAnalise"
                    label="Data de Nascimento/Fundação"
                    placeholder="Digite"
                    type="date"
                    validationType="date"
                  />
                </div>
                <div class="col-md-4">
                  <form-helper
                    :inputVar="formPreAnalise.telefone"
                    validationType="phone"
                    :form="formPreAnalise"
                    maxlength="16"
                    label="Telefone Celular"
                    placeholder="(99) 99999-9999"
                    :mask="['(##) #####-####']"
                  />
                </div>
                <button
                  v-if="currentStep == 1"
                  aria-label="Próximo"
                  style="margin-bottom: 0.5em"
                  class="btn btn-primary"
                  @click="proximo()"
                  :disabled="loader"
                >
                  Próximo <i class="fa fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </transition>

    <transition v-if="this.currentStep >= 2" name="fade">
      <template>
        <div class="panel panel-primary">
          <div
            @click="formSimulacao.showForm = !formSimulacao.showForm"
            class="panel-heading"
          >
            2 - SIMULAÇÃO<span class="pull-right">
              <i
                style="font-size: 1.5em"
                :class="
                  formSimulacao.showForm
                    ? 'fa fa-arrow-down'
                    : 'fa fa-arrow-right'
                "
                aria-hidden="true"
              ></i>
            </span>
          </div>
          <div
            v-if="formSimulacao.showForm"
            class="panel-body"
            style="padding-left: 35px"
          >
            <div>
              <div class="row">
                <div class="col-md-7">
                  <form-helper
                    :inputVar="formSimulacao.valorEntrada2"
                    :disabled="this.currentStep != 2"
                    type="range"
                    validationType="rangeValue"
                    :form="formSimulacao"
                    :min="0"
                    :max="this.formSimulacao.valorEntrada2Max"
                    :step="this.formSimulacao.valorEntrada2Step"
                    :required="false"
                    :label="
                      'Valor Entrada ' +
                      this.$options.filters.reais(
                        this.formSimulacao.valorEntrada.value
                      )
                    "
                    placeholder="0,00"
                  />
                </div>
                <div class="col-xs-10 col-md-3">
                  <form-helper
                    :inputVar="formSimulacao.valorEntrada"
                    :disabled="this.currentStep != 2"
                    :form="formSimulacao"
                    type="money"
                    :min="0"
                    :max="this.formSimulacao.valorEntrada2Max"
                    validationType="rangeValue"
                    label=""
                    placeholder="0,00"
                  />
                </div>
                <div class="col-xs-2 col-md-2">
                  <button
                    type="button"
                    :disabled="this.currentStep != 2"
                    class="btn btn-primary"
                    style="float: right; margin-top: 0.9em; width: 100%"
                    @click="this.abrirCupom"
                  >
                    Cupom
                    {{
                      this.formSimulacao.cupom.value
                        ? "Cód: " + this.formSimulacao.cupom.value
                        : ""
                    }}
                  </button>
                  <div
                    class="modal"
                    id="cupomModal"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="cupomModalLabel"
                    aria-hidden="true"
                    ref="cupomModal"
                  >
                    <div class="modal-dialog modal-sm" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" id="cupomModalLabel">
                            CUPOM DE CAMPANHA
                          </h5>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <div class="row">
                            <div class="col-md-12">
                              <p>
                                Caso possua um CUPOM DE CAMPANHA, informe-o
                                abaixo.
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12">
                              <form-helper
                                :inputVar="formSimulacao.cupom"
                                :form="formSimulacao"
                                type="number"
                                validationType="rangeValue"
                                label="Cupom"
                                placeholder="000"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                          >
                            Cancelar
                          </button>
                          <button
                            type="button"
                            @click="this.removeCupom"
                            class="btn btn-danger"
                          >
                            Remover
                          </button>
                          <button
                            type="button"
                            @click="this.adicionaCupom"
                            class="btn btn-primary"
                          >
                            Adicionar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <form-helper
                    :inputVar="formSimulacao.valor"
                    :form="formSimulacao"
                    type="money"
                    :readonly="true"
                    label="Valor para Financiar"
                    placeholder="0,00"
                  />
                </div>
                <div class="col-md-3">
                  <form-helper
                    :inputVar="formSimulacao.valorLiberado"
                    :form="formSimulacao"
                    type="money"
                    :readonly="true"
                    label="Valor Liberado"
                    placeholder="0,00"
                  />
                </div>
                <div class="col-xs-6 col-md-3">
                  <form-helper
                    :inputVar="formSimulacao.parcela"
                    :disabled="this.currentStep != 2"
                    :form="formSimulacao"
                    label="Parcela"
                    placeholder="Selecione a parcela"
                    type="select"
                    :options="sm_optionsParcela"
                  />
                </div>
                <div class="col-xs-6 col-md-3">
                  <Loader v-if="loaderStep2" />
                  <form-helper
                    v-if="this.formSimulacao.valorParcela.value > 0"
                    :inputVar="formSimulacao.valorParcela"
                    :form="formSimulacao"
                    type="money"
                    :readonly="true"
                    label="Valor Parcela"
                    placeholder="0,00"
                  />

                  <button
                    v-if="this.formSimulacao.valorParcela.value <= 0"
                    type="button"
                    class="btn btn-primary"
                    style="margin-top: 2.2em; width: 100%"
                    @click="simularParcela"
                  >
                    Simular
                  </button>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <h3 class="box-title" style="margin-top: 0px">
                    FORMA DE PAGAMENTO
                  </h3>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <form-helper
                    :inputVar="formSimulacao.firstInstallment"
                    :disabled="this.currentStep != 2"
                    :form="formSimulacao"
                    :min="this.formSimulacao.firstInstallmentMinimumDate"
                    :max="this.formSimulacao.firstInstallmentMaximumDate"
                    label="Data de Pagamento"
                    placeholder="Digite"
                    type="daterange"
                    validationType="daterange"
                  />
                </div>
                <div class="col-md-6">
                  <form-helper
                    :inputVar="formSimulacao.forma"
                    :disabled="this.currentStep != 2"
                    :form="formSimulacao"
                    label="Forma de Pagamento"
                    placeholder="Selecione a Forma de Pagamento"
                    type="select"
                    :options="sm_optionsFormaPagamento"
                  />
                </div>
                <div v-if="temFlex" class="col-md-3">
                  <form-helper
                    :inputVar="formSimulacao.flex"
                    :disabled="this.currentStep != 2"
                    :form="formSimulacao"
                    label="Modalidade"
                    placeholder="Selecione o Pacote Flex"
                    type="select"
                    :options="sm_optionsFlex"
                  />
                </div>
              </div>

              <div v-if="this.isDebitoEmConta" class="row">
                <div class="col-md-12">
                  <h3 class="box-title" style="margin-top: 0px">
                    DADOS BANCÁRIOS
                  </h3>
                </div>
              </div>
              <div v-if="this.isDebitoEmConta" class="row">
                <div class="col-md-3">
                  <form-helper
                    :inputVar="formSimulacao.agencia"
                    :disabled="this.currentStep != 2"
                    :form="formSimulacao"
                    label="Código da Agência"
                    placeholder="Digite"
                    :mask="['####']"
                  />
                </div>
                <div class="col-md-3">
                  <form-helper
                    :inputVar="formSimulacao.conta"
                    :disabled="this.currentStep != 2"
                    :form="formSimulacao"
                    label="Conta"
                    placeholder="Digite"
                    :mask="['########']"
                  />
                </div>
                <div class="col-md-2">
                  <form-helper
                    :inputVar="formSimulacao.digito"
                    :disabled="this.currentStep != 2"
                    :form="formSimulacao"
                    label="Dígito"
                    placeholder="Digite"
                    :mask="['#']"
                  />
                </div>
              </div>

              <button
                v-if="currentStep < 3 && formSimulacao.valorParcela.value > 0"
                aria-label="Próximo"
                style="margin-bottom: 0.5em"
                class="btn btn-primary"
                @click="proximo()"
                :disabled="loader"
              >
                Próximo <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </template>
    </transition>

    <transition v-if="this.currentStep >= 3" name="fade">
      <template>
        <div class="panel panel-primary">
          <div
            @click="resultadoshowForm = !resultadoshowForm"
            class="panel-heading"
          >
            3 - RESULTADO SIMULAÇÃO<span class="pull-right">
              <i
                style="font-size: 1.5em"
                :class="
                  resultadoshowForm ? 'fa fa-arrow-down' : 'fa fa-arrow-right'
                "
                aria-hidden="true"
              ></i>
            </span>
          </div>
          <div
            v-if="resultadoshowForm"
            class="panel-body"
            style="padding-left: 35px"
          >
            <div>
              <div class="content">
                <table class="table table-striped">
                  <tbody>
                    <tr>
                      <th scope="row">Valor Entrada</th>
                      <td class="text-right">
                        {{
                          (this.sm_resultadoSimulacao
                            ? this.sm_resultadoSimulacao.simulationResponse.cet
                                .valorEntrada
                            : 0) | reais
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Valor Líquido Liberado</th>
                      <td class="text-right">
                        {{
                          (this.sm_resultadoSimulacao
                            ? this.sm_resultadoSimulacao.simulationResponse.cet
                                .valorLiquidoLiberado
                            : 0) | reais
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Data Primeira Parcela</th>
                      <td class="text-right">
                        {{ this.formSimulacao.firstInstallment.value | databr }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Parcelas</th>
                      <td class="text-right">
                        {{
                          this.sm_resultadoSimulacao
                            ? this.sm_resultadoSimulacao.simulationResponse.cet
                                .qtParcelas
                            : 0
                        }}
                        vezes de
                        {{
                          (this.sm_resultadoSimulacao
                            ? this.sm_resultadoSimulacao.simulationResponse.cet
                                .valorParcela
                            : 0) | reais
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Valor Total Finananciado</th>
                      <td class="text-right">
                        {{
                          (this.sm_resultadoSimulacao
                            ? this.sm_resultadoSimulacao.simulationResponse.cet
                                .valorTotalFinananciado
                            : 0) | reais
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Valor Total Pago Final</th>
                      <td class="text-right">
                        {{
                          (this.sm_resultadoSimulacao
                            ? this.sm_resultadoSimulacao.simulationResponse.cet
                                .valorTotalPagoFinal
                            : 0) | reais
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <button
                v-if="currentStep > 1"
                aria-label="Anterior"
                style="float: left; margin-right: 1em"
                class="btn btn-primary"
                @click="anterior()"
                :disabled="loader"
              >
                <i class="fa fa-chevron-left"></i> Anterior
              </button>

              <button
                :disabled="!orcCetbtnEnabled"
                type="button"
                style="float: left; margin-right: 1em"
                class="btn btn-primary"
                @click="baixarOrcamentoCet"
              >
                CET - Baixe sua proposta pré-aprovada
              </button>

              <button
                v-if="currentStep == 3"
                aria-label="Próximo"
                style="float: left; margin-right: 1em"
                class="btn btn-primary"
                @click="proximo()"
                :disabled="loader"
              >
                Próximo <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </template>
    </transition>

    <santander-fisico
      ref="santanderFisico"
      :visible="isClienteFisico && cliente && currentStep >= 4"
      :cliente="cliente"
      :codigoPedido="sm_codigoPedido"
      :token="sm_tokenSantander"
      :uuid="sm_uuidSimulation"
      :parcelaQtde="formSimulacao.parcela.value.code"
      :parcelaValor="formSimulacao.valorParcela.value"
      :telefone="formPreAnalise.telefone.value"
      :dateOfBirthFoundation="formPreAnalise.dataNasc.value"
      :tabId="this.sm_tabId"
      :simulacaoId="simulacaoId"
      :valorEntrada="formSimulacao.valorEntrada.value"
      :valorLiberado="formSimulacao.valorLiberado.value"
      :data1aParcela="formSimulacao.firstInstallment.value"
      :agencia="formSimulacao.agencia.value"
      :conta="formSimulacao.conta.value"
      :digito="formSimulacao.digito.value"
      @re-enviar-simulacao="callReEnviarSimulacao"
    >
      <template v-slot:buttons>
        <div class="col-md-12">
          <button
            v-if="currentStep > 3"
            aria-label="Anterior"
            style="float: left; margin-right: 1em"
            class="btn btn-primary"
            @click="anterior()"
            :disabled="loader"
          >
            <i class="fa fa-chevron-left"></i> Anterior
          </button>

          <button
            v-if="currentStep == 4"
            aria-label="Próximo"
            style="float: left; margin-right: 1em"
            class="btn btn-primary"
            @click="proximo()"
            :disabled="loader"
          >
            Enviar Proposta <i class="fa fa-chevron-right"></i>
          </button>
        </div>
      </template>
    </santander-fisico>

    <santander-juridico
      ref="santanderJuridico"
      :visible="isClienteJuridico && cliente && currentStep >= 4"
      :cliente="cliente"
      :codigoPedido="sm_codigoPedido"
      :token="sm_tokenSantander"
      :uuid="sm_uuidSimulation"
      :agencia="formSimulacao.agencia.value"
      :conta="formSimulacao.conta.value"
      :digito="formSimulacao.digito.value"
      :parcelaQtde="formSimulacao.parcela.value.code"
      :parcelaValor="formSimulacao.valorParcela.value"
      :tabId="this.sm_tabId"
      :telefone="formPreAnalise.telefone.value"
      :dateOfBirthFoundation="formPreAnalise.dataNasc.value"
      :simulacaoId="simulacaoId"
      :valorEntrada="formSimulacao.valorEntrada.value"
      :valorLiberado="formSimulacao.valorLiberado.value"
      :data1aParcela="formSimulacao.firstInstallment.value"
      @re-enviar-simulacao="callReEnviarSimulacao"
    >
      <template v-slot:buttons>
        <div class="col-md-12">
          <button
            v-if="currentStep > 3"
            aria-label="Anterior"
            style="float: left; margin-right: 1em"
            class="btn btn-primary"
            @click="anterior()"
            :disabled="loader"
          >
            <i class="fa fa-chevron-left"></i> Anterior
          </button>

          <button
            v-if="currentStep == 4"
            aria-label="Próximo"
            style="float: left; margin-right: 1em"
            class="btn btn-primary"
            @click="proximo()"
            :disabled="loader"
          >
            Enviar Proposta <i class="fa fa-chevron-right"></i>
          </button>
        </div>
      </template>
    </santander-juridico>

    <transition
      name="fade"
      v-if="resultadoProposta.showPanel && currentStep == 5"
    >
      <template>
        <div :class="panelPropostaColor">
          <div
            class="panel-heading"
            @click="resultadoProposta.showForm = !resultadoProposta.showForm"
          >
            5 - RESULTADO PROPOSTA
            <span class="pull-right">
              <i
                style="font-size: 1.5em"
                :class="
                  resultadoProposta.showForm
                    ? 'fa fa-arrow-down'
                    : 'fa fa-arrow-right'
                "
                aria-hidden="true"
              ></i>
            </span>
          </div>
          <transition name="fade" v-if="resultadoProposta.showForm">
            <template>
              <div class="panel-body" :style="panelPropostaBackColor">
                <div class="row">
                  <div class="col-xs-6">
                    <span class="font-weight-bold">Data da Solicitação: </span>
                    <span>{{
                      this.resultadoProposta.proposta
                        ? this.resultadoProposta.proposta.creationDate
                        : "" | datahorabr
                    }}</span>
                  </div>
                  <div class="col-xs-6">
                    <span class="font-weight-bold">Situação: </span>
                    <span>{{
                      this.resultadoProposta.proposta
                        ? this.resultadoProposta.proposta.statusDescription
                        : ""
                    }}</span>
                  </div>
                </div>
              </div>
            </template>
          </transition>
        </div>
      </template>
    </transition>
  </main>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}

.title-article {
  font-size: 1.5em;
}

.panel-body {
  background: #f3f9ff;
}
</style>

<script>
import FormHelper from "../../FormHelper.vue";
import SantanderFisico from "./SantanderFisico.vue";
import SantanderJuridico from "./SantanderJuridico.vue";
import SantanderStepper from "../../santander/SantanderStepper";
import sm_ from "../../santander/SantanderMixing";

export default {
  name: "FinancingSantander",
  props: {
    total: {
      type: Number,
      default: 0,
    },
    codigoCliente: {
      type: String,
      default: "",
    },
    codigoPedido: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [sm_],
  components: {
    FormHelper,
    SantanderFisico,
    SantanderJuridico,
    SantanderStepper,
  },
  data() {
    return {
      loader: false,
      valorEntradaPonte: 0,
      loaderStep2: false,
      orcCetbtnEnabled: true,
      lastStep: 5,
      currentStep: 1,
      steps: [
        {
          step: 1,
          title: "Pre-Análise",
        },
        {
          step: 2,
          title: "Simulação",
        },
        {
          step: 3,
          title: "Resultado Simulação",
        },
        {
          step: 4,
          title: "Proposta",
        },
        {
          step: 5,
          title: "Resultado Proposta",
        },
      ],
      formPreAnalise: {
        documentoCliente: new this.$formInput(true),
        dataNasc: new this.$formInput(true),
        telefone: new this.$formInput(true),
        valorSimular: new this.$formInput(true),
        attemptSubmit: false,
        showForm: true,
      },
      resultadoProposta: {
        proposta: null,
        showPanel: false,
        showForm: true,
      },
      resultadoshowForm: true,
      isClienteFisico: false,
      isClienteJuridico: false,
      loaderInfos: false,
      cliente: null,
      changeFormaDePagamento: false,
    };
  },
  methods: {
    callReEnviarSimulacao: async function (tipo) {
      let r = await this.reEnviarSimulacao();
      if (tipo == "J") {
        this.$refs.santanderJuridico.simulacaoReenviada(r);
      } else {
        this.$refs.santanderFisico.simulacaoReenviada(r);
      }
    },
    load: async function () {
      this.clearMixingData();
      this.sm_codigoCliente = this.codigoCliente;
      this.sm_codigoPedido = this.codigoPedido;
      this.sm_codigoProduto = null;
      this.cliente = await this.getCliente(
        this.codigoCliente.toString().split("-")[0]
      );
      this.formPreAnalise.valorSimular.value = this.total;
      this.formPreAnalise.documentoCliente.value = this.cliente.CLI_CICCGC;
      this.formPreAnalise.dataNasc.value = this.cliente.CLI_DATANASCIMENTOFUNDACAO;
      this.formPreAnalise.telefone.value = this.cliente.CLI_FONE;
      this.isClienteFisico = this.cliente.CLI_TIPO == "F" ? true : false;
      this.isClienteJuridico = this.cliente.CLI_TIPO == "J" ? true : false;
      this.proximo();
    },

    async proximo() {
      if (this.sm_codigoCliente == null || this.sm_codigoPedido == null) return;
      await this.getToken();
      let result;
      //Before
      switch (this.currentStep) {
        case 1:
          this.step2();
          result = await this.preAnalisar();
          break;
        case 2:
          result = await this.simular(false, true);
          break;
        case 3:
          result = await this.step3();
          break;
        case 4:
          result = await this.step4();
          break;
        case 5:
          result = await this.step5();
          break;
      }

      if (!result) return;

      if (this.currentStep < this.lastStep) this.currentStep++;
      //After
      switch (this.currentStep) {
        case 1:
          this.step1();
          break;
        case 2:
          this.recalcularValorParcela();
          break;
        case 5:
          this.resultadoProposta.showPanel = true;
          break;
      }
    },

    anterior(step = null) {
      if (step != null) {
        this.currentStep = step;
        return;
      }
      if (this.currentStep > 1) this.currentStep--;
    },

    step1: function () {
      this.currentStep = 1;
      this.formPreAnalise.valorSimular.value = this.total;
    },

    step3: async function () {
      return true;
    },

    step4: async function () {
      let r;
      if (this.isClienteFisico) {
        r = await this.$refs.santanderFisico.sendProposta();
      } else {
        r = await this.$refs.santanderJuridico.sendProposta();
      }
      if (r != null) {
        this.resultadoProposta.proposta = r;
        return true;
      }
      return false;
    },

    step5: async function () {
      this.resultadoProposta.showForm = true;
      this.resultadoProposta.showPanel = true;
    },

    step2: function () {
      this.formSimulacao.valorEntrada2Max =
        this.formPreAnalise.valorSimular &&
        this.formPreAnalise.valorSimular.value
          ? parseFloat(this.formPreAnalise.valorSimular.value)
          : 0;
      this.formSimulacao.valorLiberado.value = 0;
      this.formSimulacao.valor.value = parseFloat(
        this.formPreAnalise.valorSimular.value
      );
      this.formSimulacao.valorEntrada2.value = 0;
      this.formSimulacao.valorEntrada.value = 0;
      this.formSimulacao.valorParcela.value = 0;
    },

    simularParcela: function () {
      this.formSimulacao.valorParcela.value = 0;
      this.recalcularValorParcela();
    },

    abrirCupom: function () {
      $("#cupomModal").modal("show");
    },

    removeCupom: function () {
      $("#cupomModal").modal("hide");
      this.formSimulacao.cupom.value = "";
      this.recalcularValorParcela();
    },

    adicionaCupom: function () {
      $("#cupomModal").modal("hide");
      this.recalcularValorParcela();
    },

    formatCurrency: function (v) {
      v = v.toString().replace(",", ".");
      //formata valores floats para moeda
      var formato = {
        minimumFractionDigits: 2,
        style: "currency",
        currency: "BRL",
      };
      return parseFloat(v).toLocaleString("pt-BR", formato);
    },

    unload: function () {
      this.clearMixingData();
    },
  },
  watch: {
    visible: function (val) {
      if (val) {
        this.load();
      } else {
        this.unload();
      }
    },
    total: async function (val) {
      await this.anterior(1);
      if (val && val > 0) {
        this.formPreAnalise.valorSimular.value = val;
        //this.proximo();
      }
    },
  },
  computed: {
    simulacaoId: function () {
      if (this.sm_resultadoSimulacao == null) return 0;

      if (this.sm_resultadoSimulacao.simulationResponse == null) return 0;

      return this.sm_resultadoSimulacao.simulationResponse
        .SIMULACAO_SANTANDER_ID;
    },

    panelPropostaColor: function () {
      if (this.resultadoProposta.proposta) {
        switch (this.resultadoProposta.proposta.status) {
          case "N":
            return "panel panel-danger";
          case "E":
            return "panel panel-warning";
          case "A":
            return "panel panel-success";
          default:
            return "panel panel-default";
        }
      }
      return "panel panel-default";
    },
    panelPropostaBackColor: function () {
      if (this.resultadoProposta.proposta) {
        switch (this.resultadoProposta.proposta.status) {
          case "N":
            return "background:#fff3f3;";
          case "E":
            return "background:#fffef3;";
          case "A":
            return "background:#f3fffa;";
          default:
            return "background:#fff;";
        }
      }
      return "background:#fff;";
    },
  },
};
</script>